import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-light q-postition-relative",
  style: {"height":"300px"},
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-text-center q-position-absolute q-top-50 q-start-50 q-translate-middle" }, "Niestety, nie znaleźliśmy stylizacji :(")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import {PropType} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoStylisationInfo',
  props: {
  showAlert: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (__props.showAlert)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})